// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__29RHm","footer":"ModalError_footer__2yPD8"};